import { cloneRecordIdentity } from '@orbit/data';
import { deepGet } from '@orbit/utils';
export function getInverseRelationship(schema, record, relationship, relatedRecord) {
  if (relatedRecord) {
    const recordIdentity = cloneRecordIdentity(record);
    return {
      record: recordIdentity,
      relationship,
      relatedRecord
    };
  }

  return null;
}
export function getInverseRelationships(schema, record, relationship, relatedRecords) {
  if (relatedRecords && relatedRecords.length > 0) {
    const recordIdentity = cloneRecordIdentity(record);
    return relatedRecords.map(relatedRecord => {
      return {
        record: recordIdentity,
        relationship,
        relatedRecord
      };
    });
  }

  return [];
}
export function getAllInverseRelationships(schema, record) {
  const recordIdentity = cloneRecordIdentity(record);
  const inverseRelationships = [];
  schema.eachRelationship(record.type, relationship => {
    const relationshipData = deepGet(record, ['relationships', relationship, 'data']);

    if (Array.isArray(relationshipData)) {
      for (let relatedRecord of relationshipData) {
        inverseRelationships.push({
          record: recordIdentity,
          relationship,
          relatedRecord
        });
      }
    } else if (relationshipData) {
      inverseRelationships.push({
        record: recordIdentity,
        relationship,
        relatedRecord: relationshipData
      });
    }
  });
  return inverseRelationships;
}
export function getInverseRelationshipRemovalOps(schema, inverseRelationships) {
  const ops = [];

  for (let inverseRelationship of inverseRelationships) {
    const relationshipDef = schema.getRelationship(inverseRelationship.record.type, inverseRelationship.relationship);

    if (relationshipDef.type === 'hasMany') {
      ops.push({
        op: 'removeFromRelatedRecords',
        record: inverseRelationship.record,
        relationship: inverseRelationship.relationship,
        relatedRecord: inverseRelationship.relatedRecord
      });
    } else {
      ops.push({
        op: 'replaceRelatedRecord',
        record: inverseRelationship.record,
        relationship: inverseRelationship.relationship,
        relatedRecord: null
      });
    }
  }

  return ops;
}